import { DailySettlementStatisticsReq, ServiceTypeKey } from '@/services/settlement/settlementManagement/types'
import {
  useExportExcelDailySettlementStatistics,
  useExportExcelPartnerSettlementStatistics,
} from '@/services/settlement/settlementManagement/useSettlementManagementQueries'

export const useExportExcelSettlementStatisticsDetail = (serviceType: ServiceTypeKey) => {
  const isAllServiceType = serviceType === 'ALL'

  const { isLoading: isLoadingDailySettlements, onExportData: onExportDailySettlements } = useExportExcelDailySettlementStatistics()
  const { isLoading: isLoadingPartnerSettlements, onExportData: onExportPartnerSettlements } = useExportExcelPartnerSettlementStatistics()

  const handleExportData = (params: DailySettlementStatisticsReq) => {
    if (isAllServiceType) {
      onExportDailySettlements(params)
      return
    }
    onExportPartnerSettlements({ ...params, serviceType })
  }
  return {
    isLoading: isAllServiceType ? isLoadingDailySettlements : isLoadingPartnerSettlements,
    onExportData: handleExportData,
  }
}
